<!-- eslint-disable -->
<template lang="pug">
    .battle-preview(:class="{'battle-preview--archived': battle.status === 'archived'}")
        .battle-preview__col.battle-preview__col--image
            img.battle-preview__image(
                :src="battle.logo",
            )
        .battle-preview__col
            .battle-preview__name(
                v-text="battle.name"
            )
        .battle-preview__col(v-if="battle.status !== 'archived' && !withSlot")
            .battle-preview__registration
                a(:href="battle.rulesLink" target="_blank") {{ $i18n.t('battle.battle_preview_theRulesOfTheBattle') }}
            .battle-preview__registration
                span(v-text="timeStatus")
            .battle-preview__registration(
                v-if="showStatus && (user.type === 'student')"
            )
                template(v-if="battle.authUserRegisteredLevel")
                    span(v-if="battle.authUserRegisteredLevel.authCompletedUser.length")
                        | {{ $i18n.t('olympiads.olympiads_preview_allTasksCompleted') }}
                    span(v-else) {{ $i18n.t('olympiads.olympiads_preview_applicationIsAccepted') }}
                template(v-else-if="battle.isRegistrationEnded")
                    span {{ $i18n.t('olympiads.olympiads_preview_registrationEnded') }}
        .battle-preview__col(v-else)
            .battle-preview__slot
                slot
</template>

<script>
    /*eslint-disable*/
    import moment from "moment-timezone";
    import { mapState } from 'vuex';

    const timezone = 'Europe/Moscow';

    export default {
        props: {
            battle: Object,
            withTime: Boolean,
            showStatus: Boolean,
            withSlot: Boolean
        },
        created () {
            moment.locale(this.$i18n.locale);
        },
        computed: {
            timeStatus () {
                if (this.battle.status !== 'archived') {
                    let currentTime = moment.tz(timezone);
                    if (!this.battle.start && !this.battle.end) {
                        return this.$i18n.t('battle.battle_preview_withoutTime')
                    } else if (!this.battle.start && this.battle.end) {
                        if (currentTime.isBefore(moment.tz(this.battle.end, timezone))) {
                            return this.$i18n.t('battle.battle_preview_battleWillEnd')
                                + moment(this.battle.end).format('DD MMM YYYY')
                                + this.$i18n.t('olympiads.olympiads_preview_in')
                                + moment(this.battle.end).format('HH:mm')
                                + this.$i18n.t('olympiads.olympiads_preview_timezone');
                        } else {
                            return this.$i18n.t('battle.battle_preview_battleEnded');
                        }
                    } else if (!this.battle.end && this.battle.start) {
                        if (currentTime.isBefore(moment.tz(this.battle.start, timezone))) {
                            return this.$i18n.t('battle.battle_preview_battleWillBegin')
                                + moment(this.battle.start).format('DD MMM YYYY')
                                + this.$i18n.t('olympiads.olympiads_preview_in')
                                + moment(this.battle.start).format('HH:mm')
                                + this.$i18n.t('olympiads.olympiads_preview_timezone');
                        } else {
                            return this.$i18n.t('battle.battle_preview_battleStarted');
                        }
                    } else {
                        if (this.isRegistrationAllowed) {
                            return this.$i18n.t('battle.battle_preview_battleWillEnd')
                                + moment(this.battle.end).format('DD MMM YYYY')
                                + this.$i18n.t('olympiads.olympiads_preview_in')
                                + moment(this.battle.end).format('HH:mm')
                                + this.$i18n.t('olympiads.olympiads_preview_timezone');
                        } else if (currentTime.isBefore(moment.tz(this.battle.start, timezone))) {
                            return this.$i18n.t('battle.battle_preview_battleWillBegin')
                                + moment(this.battle.start).format('DD MMM YYYY')
                                + this.$i18n.t('olympiads.olympiads_preview_in')
                                + moment(this.battle.start).format('HH:mm')
                                + this.$i18n.t('olympiads.olympiads_preview_timezone');
                        }
                    }
                }
                return this.$i18n.t('battle.battle_preview_battleEnded');
            },
            isRegistrationAllowed () {
                return moment.tz(timezone).isBetween(
                    moment.tz(this.battle.start, timezone),
                    moment.tz(this.battle.end, timezone)
                );
            },
            ...mapState({
                user: state => state.auth.user
            })
        }
    }
</script>

<style lang="scss" scoped>
    // we need this not system color, because design has it
    $border-color: #EABA5A;
    $title-color: #D0BC90;
    .battle-preview {
        @include make-grid(0);
        @include stack-space($space-base);
        &__col {
            @include make-col(12, 12, 0);
            @include stack-space($space-small);
        }

        &__col--image {
            text-align: center;
            @include make-col(12, 12, 0);
            @include media($sm) {
                @include make-offset(3, 12);
                @include make-col(6, 12, 0);
            }
            @include media($lg) {
                @include make-offset(4, 12);
                @include make-col(4, 12, 0);
            }
            @include media($xlg) {
                @include make-offset(5, 12);
                @include make-col(2, 12, 0);
            }
        }
        &__image {
            height: 100px;
            width: 100px;
            border: 3px solid $color-green-500;
            border-radius: $border-radius-circle;
            &--archived {
                border: 3px solid $border-color;
            }
        }
        &__title {
            @include text($font-size-14, $font-weight-semi-bold);
            text-align: center;
            @include stack-space($space-x-small);

            &--archived {
                color: $title-color;
            }
        }
        &__name {
            @include text($font-size-24, $font-weight-bold);
            text-align: center;
            &--archived {
                color: $border-color;
            }
        }
        &__date {
            @include text($font-size-14);
            text-align: center;
            color: $color-brown-500;
        }
        &__time-block {
            @include inline-space($space-x-small);
        }
        &__icon {
            vertical-align: middle;
        }
        &__time {
            vertical-align: middle;
        }
        &__registration {
            @include text($font-size-12);
            text-align: center;
            @include stack-space($space-x-small);
        }
        &__slot {
            color: $color-green-600;
            text-align: center;
            @include text($font-size-16, $font-weight-bold);
            @include media($sm) {
                @include inline-space($space-large);
            }
            @include media($lg) {
                @include text($font-size-16, $font-weight-bold);
            }
        }
        &--archived {
            .battle-preview__image {
                border: 3px solid $border-color;
            }
            .battle-preview__title {
                color: $title-color;
            }
            .battle-preview__name {
                color: $border-color;
            }
        }
    }
</style>
